module.exports = __webpack_public_path__ + "static/media/maf.ce555e81.jpg";